import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";

// Layouts
import MainLayout from "./components/MainLayout";

// Pages
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Editais from "./pages/Editais";
import MinhasInscricoes from "./pages/MinhasInscricoes";
import EditarMinhaInscricao from "./pages/EditarMinhaInscricao";
import AbrirRecurso from "./pages/AbrirRecurso";
import MeusRecursos from "./pages/MeusRecursos";
import DetalheRecurso from "./pages/DetalheRecurso";
import GerenciarRecursos from "./pages/GerenciarRecursos";
import DetalheRecursoControlador from "./pages/DetalheRecursoControlador";
import InscreverEdital from "./pages/InscreverEdital";
import { EditalList, EditalForm } from "./pages/GerenciarEditais";
import GerenciarCandidatos from "./pages/GerenciarCandidatos";
import { UserList, UserForm } from "./pages/GerenciarUsuarios";
import VerLogs from "./pages/VerLogs";
import GerenciarCargos from "./pages/GerenciarCargos";
import MeuPerfil from "./pages/MeuPerfil";
import DetalhesCandidato from "./pages/DetalhesCandidato";
import VerificarEmail from "./pages/VerificarEmail";
import AguardandoVerificacao from "./pages/AguardandoVerificacao";
import FAQ from "./pages/FAQ";

// Route Guards
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import ControladorRoute from "./components/ControladorRoute";

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            {/* Rotas Públicas */}
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<VerificarEmail />} />
            <Route
              path="/aguardando-verificacao"
              element={<AguardandoVerificacao />}
            />
            <Route path="/faq" element={<FAQ />} />

            {/* Rotas Protegidas com Layout */}
            <Route
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              {/* Rotas de Usuário Comum */}
              <Route path="/editais" element={<Editais />} />
              <Route path="/minhas-inscricoes" element={<MinhasInscricoes />} />
              <Route
                path="/minhas-inscricoes/:id/editar"
                element={<EditarMinhaInscricao />}
              />
              <Route path="/recurso/novo/:inscricaoId" element={<AbrirRecurso />} />
              <Route path="/meus-recursos" element={<MeusRecursos />} />
              <Route path="/recursos/:id" element={<DetalheRecurso />} />
              <Route
                path="/inscrever/:edital_id"
                element={<InscreverEdital />}
              />
              <Route path="/meu-perfil" element={<MeuPerfil />} />
              <Route path="/perfil" element={<Navigate to="/meu-perfil" />} />
              <Route path="/ajuda" element={<FAQ />} />
              {/* Rotas de Controlador */}
              <Route
                path="/controlador/editais"
                element={
                  <ControladorRoute>
                    <EditalList />
                  </ControladorRoute>
                }
              />
              <Route
                path="/controlador/editais/novo"
                element={
                  <ControladorRoute>
                    <EditalForm />
                  </ControladorRoute>
                }
              />
              <Route
                path="/controlador/editais/editar/:id"
                element={
                  <ControladorRoute>
                    <EditalForm />
                  </ControladorRoute>
                }
              />
              <Route
                path="/controlador/edital/:edital_id/candidatos"
                element={
                  <ControladorRoute>
                    <GerenciarCandidatos />
                  </ControladorRoute>
                }
              />
              <Route
                path="/candidato/:id"
                element={
                  <ControladorRoute>
                    <DetalhesCandidato />
                  </ControladorRoute>
                }
              />

              {/* Rotas de Cargos para Controlador */}
              <Route
                path="/controlador/cargos"
                element={
                  <ControladorRoute>
                    <GerenciarCargos />
                  </ControladorRoute>
                }
              />

              <Route
                path="/controlador/recursos"
                element={
                  <ControladorRoute>
                    <GerenciarRecursos />
                  </ControladorRoute>
                }
              />
              <Route
                path="/controlador/recursos/:id"
                element={
                  <ControladorRoute>
                    <DetalheRecursoControlador />
                  </ControladorRoute>
                }
              />

              {/* Rotas de Admin */}
              <Route
                path="/admin/usuarios"
                element={
                  <AdminRoute>
                    <UserList />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/usuarios/novo"
                element={
                  <AdminRoute>
                    <UserForm />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/usuarios/editar/:id"
                element={
                  <AdminRoute>
                    <UserForm />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/editais"
                element={
                  <AdminRoute>
                    <EditalList />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/editais/novo"
                element={
                  <AdminRoute>
                    <EditalForm />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/editais/editar/:id"
                element={
                  <AdminRoute>
                    <EditalForm />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/cargos"
                element={
                  <AdminRoute>
                    <GerenciarCargos />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/logs"
                element={
                  <AdminRoute>
                    <VerLogs />
                  </AdminRoute>
                }
              />

              <Route
                path="/admin/recursos"
                element={
                  <AdminRoute>
                    <GerenciarRecursos />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/recursos/:id"
                element={
                  <AdminRoute>
                    <DetalheRecursoControlador />
                  </AdminRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
